export default __webpack_public_path__ + "static/card_1-ea42c0aa8951bba15231008d02b0a604.png";